import { useTranslation } from 'next-i18next';
import { LoadingSpinner } from '../../common';
import { usePlanPaymentInfoContext } from './Providers';
export const PlanPaymentLoading = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    isPlanPaymentLoading
  } = usePlanPaymentInfoContext();
  return <>
      {isPlanPaymentLoading && <LoadingSpinner text={t('subscription:payment.processing.title', '결제 처리 중입니다')} description={t('subscription:payment.processing.descriptionDelay', '"최대 2분이 소요될 수 있습니다. \n' + '잠시만 기다려 주세요."')} />}
    </>;
};